import React, { createContext, useContext, useEffect, useState } from 'react'

export type Flags = { budgets: boolean; recurring_expense: boolean; loaded: boolean }

const FlagsContext = createContext<Flags>({ budgets: false, recurring_expense: false, loaded: false })

export const useFlags = (): Flags => useContext(FlagsContext)

export const FlagsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [flags, setFlags] = useState<Flags>({ budgets: false, recurring_expense: false, loaded: false })

  useEffect(() => {
    fetch('/api/feature_flags')
      .then((r) => r.json())
      .then((data) => setFlags({ ...data, loaded: true }))
      .catch(() => setFlags((f) => ({ ...f, loaded: true })))
  }, [])

  return <FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>
}
